import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2 12.695l2.605-2.437a1 1 0 0 1 .683-.27H12.2c.993 0 1.8-.81 1.8-1.813V3.813A1.807 1.807 0 0 0 12.2 2H3.8C2.807 2 2 2.81 2 3.813v8.882zm3.683-.707l-4 3.742C1.044 16.328 0 15.875 0 15V3.813C0 1.708 1.7 0 3.8 0h8.4C14.3 0 16 1.708 16 3.813v4.362c0 2.105-1.7 3.813-3.8 3.813H5.683z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-notes"}) } }